import { toast } from '@oy/uidesktop';
import { useContext } from 'react';
import { HelpAndDocumentationContext } from './useHelpAndDocumentationContext';

export const useFaq = () => {
  // Utilize to customize the FAQ functionality
  const { onClickCategory, data } = useContext(HelpAndDocumentationContext);

  // handle FAQ category click convert id_prefix to index
  const handleFaqCategoryClick = ({
    id_prefix,
    subCategoryPrefix,
    subCategoryIndex,
    onParentClose,
    customHeader,
    customTitle,
    useCategoryTitleAsHeader,
  }: {
    id_prefix: string;
    subCategoryPrefix?: string[];
    subCategoryIndex?: number;
    onParentClose?: () => void;
    customHeader?: string;
    customTitle?: string;
    useCategoryTitleAsHeader?: boolean;
  }) => {
    const index = data.findIndex(category => category.id_prefix === id_prefix);
    if (index === -1) {
      toast.error('Invalid FAQ category ID prefix');
      return;
    }

    onClickCategory({
      index,
      subCategoryPrefix,
      subCategoryIndex,
      onParentClose,
      customHeader,
      customTitle,
      useCategoryTitleAsHeader,
    });
  };

  return { handleFaqCategoryClick };
};
